export const isInRange = (x: number, range: [number, number]) => {
    return ((x - range[0]) * (x - range[1]) <= 0);
}


